import React from "react";
import {useHistory, withRouter} from "react-router-dom";
import URL from "../../../../constant/URL";
import { useLearningHistory } from "../../../../hooks";
import Header from "./Header";

const Guide2 = withRouter((props) => {
  const { onLearninStartBtn} = useLearningHistory();
  const history = useHistory();

  const moveBack = () => {
    props.history.replace({
      pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.GUIDE1
    });
  };

  const moveNext = () => {
    onLearninStartBtn({
      type : 'replace',
      viewPath : history.location.pathname
    });
  };

  return (
    <div className="layout-def layout-lc">
      <Header />
      <div className="container">
        <div className="inner">
          <div className="centermiddleBox">
            <div className="centermiddleBox-item">
              <div className="aic-intro">
                <div className="aic-intro-item">
                  <h2 className="tit">하지만<br/>웅진 AI 진단테스트는 다릅니다!</h2>
                </div>
                <div className="aic-intro-item">
                  <p className="txt-normal txt-gray">
                    수십만 학습자의 풀이 데이터를 기반으로<br/>
                    학습 시작점을 디테일하게 찾아낸 다음
                  </p>
                </div>
                <div className="aic-intro-item">
                  <div className="imgBox">
                    <img src={`${ process.env.PUBLIC_URL }/static/images/common/img_lc_02_02_mo.png`} alt=""/>
                  </div>
                </div>
                <div className="aic-intro-item">
                  <div className="btmTxt-skyBox">
                    <p className="txt-bigger txt-sky">
                      학습자 개인별로 완전히 다른<br/>
                      코스학습을 설계해 드립니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-inner">
          <div className="d-flex">
            <div className="d-item">
              <button className="btn-small btn-gray btn-left"><span className="m-txt" onClick={moveBack}>이전</span></button>
            </div>
            <div className="d-item btnItem-auto">
              <button className="btn btn-blue" onClick={moveNext}>다음</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

});

export default Guide2;
